import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Podcasts from "@/pages/Podcasts";

export const Route = createFileRoute("/_app/podcasts/")({
  component: () => (
    <PageGate pageKey="podcasts"><Podcasts /></PageGate>
  ),
});
